//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Gender
import com.tixforgigs.apax.models.GeoPoint

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The address model
* 
* @param addressId The address id
* @param addressAddition The address addition
* @param city The city
* @param companyName The company
* @param countryCode The two letter ISO 3166-1 country code
* @param familyName The family name of the user
* @param gender 
* @param givenName The given name
* @param houseNumber The house number
* @param isInvoiceAddress invoice address
* @param isOrganizerAddress organizer address
* @param isPresaleAddress presale address
* @param isShippingAddress shipping address
* @param location 
* @param postalCode The postal code (zip code)
* @param region The region (federal state)
* @param street The street
*/
@Serializable

data class Address (


      /* The address id */
    @SerialName(value = "addressId") @Required val addressId: kotlin.Int = -1,


      /* The address addition */
    @SerialName(value = "addressAddition") val addressAddition: kotlin.String? = null,


      /* The city */
    @SerialName(value = "city") val city: kotlin.String? = null,


      /* The company */
    @SerialName(value = "companyName") val companyName: kotlin.String? = null,


      /* The two letter ISO 3166-1 country code */
    @SerialName(value = "countryCode") val countryCode: kotlin.String? = null,


      /* The family name of the user */
    @SerialName(value = "familyName") val familyName: kotlin.String? = null,


      @SerialName(value = "gender") val gender: Gender? = null,


      /* The given name */
    @SerialName(value = "givenName") val givenName: kotlin.String? = null,


      /* The house number */
    @SerialName(value = "houseNumber") val houseNumber: kotlin.String? = null,


      /* invoice address */
    @SerialName(value = "isInvoiceAddress") val isInvoiceAddress: kotlin.Boolean? = null,


      /* organizer address */
    @SerialName(value = "isOrganizerAddress") val isOrganizerAddress: kotlin.Boolean? = null,


      /* presale address */
    @SerialName(value = "isPresaleAddress") val isPresaleAddress: kotlin.Boolean? = null,


      /* shipping address */
    @SerialName(value = "isShippingAddress") val isShippingAddress: kotlin.Boolean? = null,


      @SerialName(value = "location") val location: GeoPoint? = null,


      /* The postal code (zip code) */
    @SerialName(value = "postalCode") val postalCode: kotlin.String? = null,


      /* The region (federal state) */
    @SerialName(value = "region") val region: kotlin.String? = null,


      /* The street */
    @SerialName(value = "street") val street: kotlin.String? = null


) {




  }

